<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-if="loading_page === false">
      <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert" v-if="alert_success === true">เปลี่ยนสถานะเรียบร้อย !</v-alert>
      </v-slide-x-reverse-transition>
      <v-card elevation="6">
        <div class="pa-3">
          <div class="text-right">
            <router-link to="/stock/promotion_stock/promotionaddgroup">
              <v-btn class="pa-6 grad-success-bg white--text btn_mobile">จัดกลุ่มสินค้าคละ</v-btn>
            </router-link>
          </div>
        </div>
        <div class="pa-2">
          <v-card-title>
            <v-text-field color="#86bc3a" v-model="search" append-icon="mdi-magnify" label="ค้นหา" single-line hide-details></v-text-field>
          </v-card-title>
          <v-data-table :headers="headers" :items="data_list" :search="search" :footer-props="footer_Props" mobile-breakpoint="0">
            <template v-slot:item="dataDetail">
              <tr>
                <td>{{ dataDetail.item.promotion_code }}</td>
                <td>{{ dataDetail.item.name }}</td>
                <td>{{ dataDetail.item.count_sale }}</td>
                <td>
                  <div v-if="dataDetail.item.show_promotion_set === '1'">แสดงทั้งขายปลีก, ขายส่ง</div>
                  <div v-else-if="dataDetail.item.show_promotion_set === '2'">แสดงเฉพาะขายปลีก</div>
                  <div v-else-if="dataDetail.item.show_promotion_set === '3'">แสดงเฉพาะขายส่ง</div>
                </td>
                <td>
                  <div v-if="dataDetail.item.switch_disabled !== true">{{ diff_dateTH(dataDetail.item.end_date) }}</div>
                  <div v-else style="color: red">{{ diff_dateTH(dataDetail.item.end_date) }}</div>
                </td>
                <td><v-switch color="#86bc3a" @change="changeStatus(dataDetail.item.id, dataDetail.item.status)" v-model="dataDetail.item.status" :disabled="dataDetail.item.switch_disabled"></v-switch></td>
                <td class="pa-3">
                  <v-btn small height="42" @click="getDetails(dataDetail.item.id)" class="grad-success-bg white--text mr-1 mb-1">
                    <v-icon>mdi-magnify</v-icon>
                  </v-btn>
<!--                  <v-btn small height="42" @click="getDetails(dataDetail.item.id)" class="grad-success-bg white&#45;&#45;text mr-1 mb-1">-->
<!--                    <v-icon>mdi-magnify</v-icon>-->
<!--                  </v-btn>-->
                </td>
              </tr>
            </template>
          </v-data-table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import {HTTP} from "@/axios";
import {diffDateTH} from "@/js/handler";

export default {
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Promotion_assorted",
  data() {
    return {
      loading_page: false,
      search: null,
      alert_success: false,
      date_now: null,
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'รหัสโปรโมชั่น',
          value: 'promotion_code',
          fixed: true,
          width: '120px',
        },
        {
          text: 'ชื่อ',
          value: 'name',
          fixed: true,
          width: '300px',
        },
        {
          text: 'ยอดขาย',
          value: 'count_sale',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สถานะแสดงการขาย',
          value: 'show_promotion_set',
          fixed: true,
          width: '200px',
        },
        {
          text: 'วันที่สิ้นสุด',
          value: 'end_date',
          fixed: true,
          width: '150px',
        },
        {
          text: 'สถานะ',
          value: 'status',
          sortable: false,
          fixed: true,
          width: '150px',
        },
        {
          text: 'จัดการ',
          value: '',
          sortable: false,
          fixed: true,
          width: '150px',
        },
      ],
      data_list: []
    }
  },
  methods: {
    get_date() {
      let date_today = new Date();
      let day = date_today.getDate();
      let month = date_today.getMonth() + 1;
      let year = date_today.getFullYear();
      if (month < 10){
        month = '0'+ month
      }
      if (day < 10){
        day = '0'+ day
      }
      let date = year + '-' + month + '-' + day
      this.date_now = Date.parse(date)
    },
    get_data() {
      this.loading_page = true
      this.data_list = []
      HTTP.post('/inventory/promotions/sets/all')
          .then((res) => {
            if (res.data.success === true) {
              this.loading_page = false
              res.data.object.forEach((data) => {
                let date_res = Date.parse(data.end_date)
                this.data_list.push({
                  created_at: data.created_at,
                  detail: data.detail,
                  end_date: data.end_date,
                  id: data.id,
                  is_delete: data.is_delete,
                  name: data.name,
                  pic: data.pic,
                  price_per_set: data.price_per_set,
                  promotion_code: data.promotion_code,
                  count_sale: data.count_sale,
                  show_promotion_set: data.show_promotion_set,
                  status: this.date_now > date_res ? 0 : data.status,
                  total_sell: data.total_sell,
                  updated_at: data.updated_at,
                  user_id: data.user_id,
                  user_name: data.user_name,
                  switch_disabled: this.date_now > date_res ? true : false,
                })
              })
              this.data_list.sort((a, b) => {
                return parseFloat(b.status) - parseFloat(a.status);
              })
            }
          })
    },
    diff_dateTH: function (value) {
      return diffDateTH(value)
    },
    getDetails(id) {
      this.$router.push('/stock/promotion_stock/promotiondetailsgroup/' + id);
    },
    getEdit(id) {
      this.$router.push('/stock/promotion_stock/promotioneditgroup/' + id)
    },
    changeStatus(id, status) {
      HTTP.post('/inventory/promotions/sets/changestatus', {
        id: id,
        status: status
      }).then((res) => {
        if (res.data.success === true) {
          this.alert_success = true;
          setTimeout(() => this.alert_success = false, 2000);
        }
      })
      this.alert_success = true;
      setTimeout(() => this.alert_success = false, 2000);
    },
  },
  mounted() {
    this.get_date()
    this.get_data()
  }
}
</script>

<style scoped>
.alert {
  margin: 0;
  position: fixed !important;
  z-index: 9999;
  top: 15px;
  right: 5px;
}
@media only screen and (max-width: 600px){
  .btn_mobile {
    width: 100%;
  }
}
</style>
